<template>
  <div>
    <MasterDataUsedTags :environmentId="environmentId" />
  </div>
</template>

<script setup lang="ts">
import MasterDataUsedTags from '@/components/pages/MasterDataUsedTags.vue'
import { useConfigStore } from '@/stores/config'
import { computed, onMounted } from 'vue'

const configStore = useConfigStore()
const route = useRoute()

const environmentId = computed(() => {
  const environmentName = (route.params as any).environment as string
  return configStore.environments.find((env: any) => env.name === environmentName)?.id || 0
})

onMounted(async () => {
  // Ensure environments are loaded
  if (configStore.environments.length === 0) {
    await configStore.fetchDataEnvironment()
  }
})
</script>
